import { ApiEndpoints } from '../constantes/ApiEndpoints';
import {
  SendOtpRequest,
  SendOtpResponse,
  ValidateOtpRequest,
  ValidateOtpResponse,
  ValidateResetPasswordOtpRequest,
  ValidateResetPasswordOtpResponse
} from '../_types/otp.types';
import { apiUserAccount } from '../../../utils/ApiService';
import { getSchemaIdFromStorage } from '../../../utils/getSchemaIdFromStorage';

// export const sendOtpService = async (data: SendOtpRequest): Promise<SendOtpResponse> => await apiUserAccount.post<SendOtpResponse>(ApiEndpoints.auth.requestOtpCode, data);
//
// export const validateOtpService = async (data: ValidateOtpRequest): Promise<ValidateOtpResponse> => await apiUserAccount.post<ValidateOtpResponse>(ApiEndpoints.auth.validateOtpCode, data);
//
// export const validateOtpForgotPasswordCode = async (
//   data: ValidateResetPasswordOtpRequest
// ): Promise<ValidateResetPasswordOtpResponse> => await apiUserAccount.post<ValidateResetPasswordOtpResponse>(
//   ApiEndpoints.account.recoveryCheckCode,
//   data
// );

export const useOtpService = () => ({
  sendOtp: async (data: SendOtpRequest): Promise<SendOtpResponse> => {
    const schemaId = getSchemaIdFromStorage();
    
    return await apiUserAccount.post<SendOtpResponse>(`${ApiEndpoints.auth.requestOtpCode}?schemaId=${schemaId}`, data);
  },
  
  validateOtp: async (data: ValidateOtpRequest): Promise<ValidateOtpResponse> => {
    const schemaId = getSchemaIdFromStorage();
    
    return await apiUserAccount.post<ValidateOtpResponse>(`${ApiEndpoints.auth.validateOtpCode}?schemaId=${schemaId}`, data);
  },
  
  validateOtpForgotPasswordCode: async (data: ValidateResetPasswordOtpRequest): Promise<ValidateResetPasswordOtpResponse> => {
    const schemaId = getSchemaIdFromStorage();

    return await apiUserAccount.post<ValidateResetPasswordOtpResponse>(`${ApiEndpoints.account.recoveryCheckCode}?schemaId=${schemaId}`, data)
  }
});
